export const FACEBOOK_APP_VERSION = '4.0';
export const FACEBOOK_PERMISSIONS = 'public_profile, email';
